import { Box } from "@material-ui/core";
import QuoteDetailsHeader from "./QuoteDetailsHeader";
import QuoteDetailsTable from "./QuoteDetailsTable";
import { Quote } from "../../../../api/Quote/Quote";
import { QuoteDetail } from "./QuoteDetail";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

interface Props {
  quote: Quote;
}

export const QuoteDetails = ({ quote }: Props) => {
  const { isMoreThanMd } = useBreakpoint();
  if (quote == null) {
    return null;
  }

  return (
    <Box display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
      <Box
        width={"100%"}
        marginBottom={isMoreThanMd ? "90px" : "20px"}
        boxShadow={isMoreThanMd ? "none" : "0 5px 15px 0 rgba(0, 0, 0, 0.07)"}
        bgcolor={"#fff"}
        borderRadius={"4px"}
        padding={isMoreThanMd ? 0 : "23px"}
      >
        <QuoteDetail quote={quote} />
      </Box>
      <Box
        width={"100%"}
        boxShadow={isMoreThanMd ? "none" : "0 5px 15px 0 rgba(0, 0, 0, 0.07)"}
        bgcolor={"#fff"}
        borderRadius={"4px"}
        paddingBottom={isMoreThanMd ? 0 : "31px"}
      >
        <QuoteDetailsHeader quote={quote} quoteName={quote.name} />

        <QuoteDetailsTable quote={quote} />
      </Box>
      <Box
        display={"flex"}
        flexDirection={isMoreThanMd ? "row" : "column"}
        alignItems={"center"}
        marginTop={isMoreThanMd ? "70px" : "39px"}
        marginBottom={"30px"}
      ></Box>
    </Box>
  );
};
